import { Component, OnDestroy, inject } from '@angular/core';

import { LAZY_SERVICE_TOKEN } from '@camelot/notification';
import { CamTranslationService } from '@camelot/translation';
import { CamAbstractComponent } from '@camelot/utils';

@Component({
  template: '',
  standalone: false,
})
export abstract class AbstractComponent extends CamAbstractComponent implements OnDestroy {
  protected _translationService = inject(CamTranslationService);
  protected _notificationService = inject(LAZY_SERVICE_TOKEN);

  constructor() {
    super();
  }

  public trackById(_: any, item: { id: number | string }) {
    return item.id;
  }

  public trackByKey(_: any, item: { key: string }) {
    return item.key;
  }
}
